const getProductAttributes = (product) => {
    if (product === undefined || Object.keys(product || {}).length === 0) return "";

    if (product?.checkout_attributes?.FITS) return product.checkout_attributes.FITS;

    if (product?.productType) return product.productType;

    if (product?.title) return product.title;

    return "";
};

export default getProductAttributes;
